export default {
  googleAnalyticsId: null,
  pasos: {
    paso1: {
      path: "/",
      component: "views/ReferidosEmprendedores"
    },
    referidos: {
      path: "/:origen?",
      component: "views/ReferidosEmprendedores"
    }
  }
};
